import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import supabase from '../supabase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSiteLang as useLang } from '../siteLang';



// Repris tel quel du style de Region.jsx — même look de card
const styles = `
.region-grid{
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
    gap:42px 26px;
    box-sizing:border-box;
    }
    .album-card{
        width:100%;
        box-sizing:border-box;
        cursor:pointer;
        transition:transform .25s ease;
        }
        .album-card:hover{
            transform:translateY(-2px);
            }

            .album-cover{
                position:relative;
                width:100%;
                background:#ece8df;
                overflow:hidden;
                border-radius:0;
                box-shadow:0 8px 24px rgba(17,17,17,0.12);
                transition:box-shadow .25s ease;
                }
                /* Truc "padding-top:100%" — garantit un carré parfait
                   quel que soit le support de aspect-ratio du navigateur. */
                .album-cover::before{
                    content:'';
                    display:block;
                    padding-top:100%;
                    }

                .album-card:hover .album-cover{
                    box-shadow:0 14px 32px rgba(17,17,17,0.18);
                    }

                    .album-cover img,
                    .album-cover .album-cover-placeholder{
                        position:absolute;
                        top:0; left:0;
                        width:100%;
                        height:100%;
                        object-fit:cover;
                        display:block;
                        transition:transform .45s ease;
                        }

                        .album-card:hover img{
                            transform:scale(1.02);
                            }

                            .album-meta{
                                margin-top:14px;
                                }

                                .album-title{
                                    font-family:"Helvetica Neue",Arial,sans-serif;
                                    font-size:15px;
                                    font-weight:400;
                                    color:#111;
                                    margin:0;
                                    line-height:1.4;
                                    }

                                    .album-author{
                                        font-family:"Helvetica Neue",Arial,sans-serif;
                                        font-size:12px;
                                        color:#666;
                                        margin-top:4px;
                                        }

                                        .album-details{
                                            font-family:"Helvetica Neue",Arial,sans-serif;
                                            font-size:11px;
                                            color:#999;
                                            margin-top:8px;
                                            }

                                            .year-heading{
                                                font-family:"Helvetica Neue",Arial,sans-serif;
                                                font-size:28px;
                                                font-weight:600;
                                                color:#111;
                                                margin:0 0 28px;
                                                }

/* Mobile : liste horizontale compacte (miniature + texte à côté) plutôt
   que des grandes cartes empilées en pleine largeur — plus rapide à
   parcourir et beaucoup moins de scroll pour un même nombre d'albums. */
@media(max-width:700px){
    .region-grid{
        grid-template-columns:1fr;
        gap:0;
        }

    .album-card{
        display:flex;
        align-items:center;
        gap:20px;
        padding:24px 0;
        border-bottom:1px solid rgba(17,17,17,0.08);
        transition:opacity .2s ease;
        }
    .album-card:first-child{
        padding-top:0;
        }
    .album-card:hover{
        transform:none;
        opacity:0.72;
        }

    .album-cover{
        width:38%;
        min-width:38%;
        max-width:38%;
        border-radius:0;
        box-shadow:0 6px 16px rgba(17,17,17,0.14);
        }
    .album-card:hover .album-cover{
        box-shadow:0 6px 16px rgba(17,17,17,0.14);
        }
    .album-card:hover img{
        transform:none;
        }

    .album-meta{
        margin-top:0;
        min-width:0;
        flex:1;
        }
    .album-title{
        font-size:16.5px;
        line-height:1.35;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp:3;
        -webkit-box-orient:vertical;
        }
    .album-author{
        font-size:12.5px;
        margin-top:6px;
        }
    .album-details{
        font-size:11.5px;
        margin-top:10px;
        line-height:1.5;
        }

    .year-heading{
        font-size:21px;
        margin-bottom:6px;
        }
    }
`;

function Chroniques() {
    const { lang } = useLang();
    const t = { fr: { title: 'Chroniques', subtitle: 'Photographies, récits et archives classés par année.' }, en: { title: 'Chronicles', subtitle: 'Photographs, stories and archives sorted by year.' }, vi: { title: 'Biên niên sử', subtitle: 'Ảnh, câu chuyện và lưu trữ theo năm.' } }[lang] || { title: 'Chroniques', subtitle: '...' };
    const navigate = useNavigate();
    const [albums, setAlbums] = useState([]);
    const [loading, setLoading] = useState(true);
    const UI_FONT = 'Helvetica Neue, Arial, sans-serif';
    const color = '#000000';
    useEffect(() => { document.title = 'Chronicles | winston.ie'; }, []);

    useEffect(() => {
        const fetchAlbums = async () => {
            const { data, error } = await supabase
                .from('albums')
                .select('*')
                .eq('archived', false)
                .order('date', { ascending: false });

            console.log(data, error);
            console.log("Albums :", data);
            console.log("Erreur :", error);

            if (!error && data) setAlbums(data);
            setLoading(false);
            if (!error && data) setAlbums(data);
            setLoading(false);
        };
        fetchAlbums();
    }, []);

    // Groupé par année, année la plus récente en premier
    const groupedByYear = useMemo(() => {
        const groups = {};
        albums.forEach(album => {
            const year = album.date
                ? new Date(album.date).getFullYear()
                : 'Sans date';
            if (!groups[year]) groups[year] = [];
            groups[year].push(album);
        });
        return Object.entries(groups).sort((a, b) => (b[0] === 'Sans date' ? -1 : a[0] === 'Sans date' ? 1 : b[0] - a[0]));
    }, [albums]);

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#ffffff' }}>
            <style>{styles}</style>

            <Navbar variant="light" />
            <div style={{ maxWidth: '1100px', margin: '0 auto', width: '100%', padding: '48px 24px 80px', flex: 1 }}>

                <h1
                    style={{
                        background: 'none', border: 'none', padding: 0,
                        fontFamily: UI_FONT, fontWeight: 300,
                        fontSize: 'clamp(30px, 6vw, 52px)', letterSpacing: '-0.01em',
                        lineHeight: 1, color,
                    }}>
                    {t.title}
                </h1>

                <p
                    style={{
                        fontFamily: '"Helvetica Neue",Arial,sans-serif',
                        color: '#777',
                        fontSize: '14px',
                        lineHeight: 1.6,
                        marginBottom: '70px'
                    }}>
                    {t.subtitle}
                </p>

                {loading ? (
                    <p style={{ fontFamily: 'Helvetica Neue, sans-serif', fontSize: '13px', color: '#999' }}>Chargement...</p>
                ) : groupedByYear.length === 0 ? (
                    <p style={{ fontFamily: 'Helvetica Neue, sans-serif', fontSize: '13px', color: '#999' }}>Aucun album pour le moment.</p>
                ) : (
                    groupedByYear.map(([year, yearAlbums]) => (
                        <div key={year} style={{ marginBottom: '56px' }}>
                            <h2 className="year-heading">{year}</h2>
                            <div className="region-grid">
                                {yearAlbums.map(album => (
                                    <div
                                        key={album.folder}
                                        className="album-card"
                                        onClick={() => navigate(`/region/${album.region}/${album.folder}`)}
                                    >

                                        <div className="album-cover">
                                            {album.cover_url ? (
                                                <img src={album.cover_url} alt={album.title} />
                                            ) : (
                                                <div className="album-cover-placeholder" style={{ background: "#ece8df" }} />
                                            )}
                                        </div>

                                        <div className="album-meta">

                                            <p className="album-title">
                                                {album.title}
                                            </p>

                                            <p className="album-author">
                                                {album.created_by || "Winston.ie"}
                                            </p>

                                            <p className="album-details">
                                                {album.location || album.region}
                                                {album.date && ` · ${new Date(album.date).toLocaleDateString("fr-CA", {
                                                    year: "numeric",
                                                    month: "long",
                                                    day: "numeric"
                                                })}`}
                                            </p>

                                        </div>

                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                )}
            </div>

            <Footer variant="light" />
        </div>
    );
}

export default Chroniques;